<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout wrap>
    <v-flex xs12 class="create-hotel-container">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-tabs v-model="tab.value" grow background-color="teal lighten-5">
          <v-tabs-slider color="primary"/>
          <v-tab v-for="tab in tab.tabs" :key="tab.label">
            {{ tab.label }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab.value">
          <v-tab-item v-for="tab in tab.tabs" :key="tab.value">
            <v-card flat v-if="tab.value === 0">
              <v-card-text>
                <v-layout wrap row justify-center>
                  <v-flex xs12 sm12 md5>
                    <v-text-field
                      v-model="hotelDTO.name"
                      :rules="rules"
                      :label="$t('hotel.name')"
                      required/>
                    <v-text-field
                      v-model="hotelDTO.externalId"
                      :rules="rules"
                      label="Property Code"
                      required/>
                    <v-text-field
                      v-model="hotelDTO.url"
                      :rules="rules"
                      :label="$t('hotel.url')"/>
                    <h2>{{ $t('hotel.contact.text') }}</h2>
                    <v-text-field
                      v-model="hotelDTO.contact.contactName"
                      :rules="rules"
                      :label="$t('hotel.contact.name')"
                      required/>
                    <v-text-field
                      v-model="hotelDTO.contact.contactEmail"
                      :rules="emailRules"
                      :label="$t('hotel.contact.email')"
                      required/>
                    <h2>{{ $t('hotel.address.contact') }}</h2>
                    <v-text-field
                      v-model="hotelDTO.address.landLine"
                      :label="$t('hotel.address.landLine')"/>
                    <v-text-field
                      v-model="hotelDTO.address.mobile"
                      :label="$t('hotel.address.mobile')"/>
                    <v-text-field
                      v-model="hotelDTO.address.fax"
                      :label="$t('hotel.address.fax')"/>
                    <v-text-field
                      v-model="hotelDTO.address.email"
                      :label="$t('hotel.address.email')"/>
                  </v-flex>
                  <v-flex xs12 sm12 md5 offset-md1>
                    <v-layout wrap row>
                      <v-select
                        :items="hotelTypes"
                        item-text="label"
                        item-value="value"
                        v-model="hotelDTO.hotelType"
                        :label="$t('hotel.selectHotelType')"
                        :rules="rules"
                        :disabled="hotelDTO.hotelType !== undefined"
                        :hint="$t('hotel.kognitiv.onlyOnce')"
                        persistent-hint
                        required/>
                    </v-layout>
                    <v-layout wrap row>
                      <v-checkbox color="primary"
                                  v-model="hotelDTO.noChildren"
                                  label="Es sind keine Kinderregelungen erlaubt"
                      />
                    </v-layout>
                    <v-layout wrap row>
                      <v-checkbox color="primary"
                                  v-model="hotelDTO.roundPrice"
                                  label="Preise kaufmännisch runden"
                      />
                    </v-layout>
                    <v-layout wrap row>
                      <h2>{{ $t('hotel.address.text') }}</h2>
                    </v-layout>
                    <v-layout wrap row>
                      <v-text-field
                        v-model="hotelDTO.address.addressLine1"
                        :label="$t('hotel.address.addressLine1')"/>
                    </v-layout>
                    <v-layout wrap row>
                      <v-text-field
                        v-model="hotelDTO.address.addressLine2"
                        :label="$t('hotel.address.addressLine2')"/>
                    </v-layout>
                    <v-layout wrap row>
                      <v-flex xs12 sm5>
                        <v-text-field
                          v-model="hotelDTO.address.zip"
                          :label="$t('hotel.address.zip')"/>
                      </v-flex>
                      <v-flex xs12 sm5 offset-sm2>
                        <v-text-field
                          v-model="hotelDTO.address.city"
                          label="Ort"/>
                      </v-flex>
                      <v-flex xs12 sm5>
                        <v-text-field
                          v-model="hotelDTO.address.region"
                          :label="$t('hotel.address.region')"/>
                      </v-flex>
                      <v-flex xs12 sm5 offset-sm2>
                        <v-text-field
                          v-model="hotelDTO.address.land"
                          :counter="2" :label="$t('hotel.address.land')"/>
                      </v-flex>
                      <h2>{{ $t('hotel.address.gps') }}</h2>
                      <v-flex xs12 sm5>
                        <v-text-field
                          v-model="hotelDTO.address.gps.longitude"
                          :label="$t('hotel.address.longitude')"/>
                      </v-flex>
                      <v-flex xs12 sm5 offset-sm2>
                        <v-text-field
                          v-model="hotelDTO.address.gps.latitude"
                          :label="$t('hotel.address.latitude')"/>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card flat v-if="tab.value === 1">
              <v-card-text>
                <v-layout wrap row justify-center>
                  <v-flex xs12 sm12 md5>
                    <h2>{{ $t('hotel.user.manager') }}</h2>
                    <v-text-field
                      v-model="hotelDTO.managerDTO.firstName"
                      :rules="rules"
                      :label="$t('contact.firstName')"
                      required/>
                    <v-text-field
                      v-model="hotelDTO.managerDTO.lastName"
                      :rules="rules"
                      :label="$t('contact.lastName')"
                      required/>
                    <v-text-field
                      v-model="hotelDTO.managerDTO.password"
                      :rules="rules"
                      :label="$t('profile.password')"
                      required/>
                    <v-text-field
                      v-model="hotelDTO.managerDTO.username"
                      :rules="emailRules"
                      :label="$t('hotel.contact.email')"
                      required/>
                  </v-flex>
                  <v-flex xs12 sm12 md5 offset-md1>
                    <h2>{{ $t('hotel.user.staff') }}</h2>
                    <v-data-table
                      :headers="staff.headers"
                      :items="hotelDTO.staffDTO">
                      <template v-slot:item="props">
                        <tr>
                          <td class="text-sm-left">
                            <p/>
                            <h3>{{ props.item.firstName }} {{ props.item.lastName }}</h3>
                            <p>{{ props.item.username }}</p>
                          </td>
                          <td>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon @click="removeStaff(props.item)" v-on="on" color="red">delete_forever</v-icon>
                              </template>
                              <span>{{ $t("delete") }}</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                    <v-layout wrap row align-left>
                      <v-btn color="primary" outlined @click="staff.dialog = true" style="margin-left: 0">
                        <v-icon left>person_add</v-icon>
                        {{ $t('hotel.user.addStaff') }}
                      </v-btn>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card flat v-if="tab.value === 2">
              <v-card-text>
                <v-layout wrap row>
                  <v-flex xs12>
                    <v-data-table
                      :headers="room.headers"
                      :items="hotelDTO.casablancaHotelRooms"
                      :items-per-page="50"
                      hide-default-footer
                      item-key="name">
                      <template v-slot:item="props">
                        <tr>
                          <td>
                            <h2 style="margin-top: 10px">{{ props.item.name }}</h2>
                            <p style="margin-bottom: 10px">Casablanca ID: <strong>{{ props.item.externalId }}</strong></p>
                          </td>
                          <td>
                            <v-btn @click="manageRateMatrix(props.item)"
                                   outlined color="primary">
                              <v-icon left dark>edit</v-icon>
                              Raten-Matrix bearbeiten
                            </v-btn>
                          </td>
                          <td>
                            <v-icon color="primary" @click="editRoom(props.item)">edit</v-icon>
                            <v-icon color="red" @click="deleteRoom(props.item)">delete</v-icon>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                    <v-btn color="primary" :disabled="hotelDTO.hotelType === undefined"
                           outlined @click="createRoom()"><v-icon left dark>add</v-icon>Zimmer anlegen</v-btn>
                    <div style="color: red;" v-if="hotelDTO.hotelType === undefined">
                      Wählen Sie den Hoteltyp aus, um ein Zimmer anlegen zu können!
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-form>
      <v-layout wrap mt-2>
        <v-flex xs12>
          <div class="divider-fix"></div>
        </v-flex>
        <v-flex xs12>
          <v-alert :value="hotelForm.valid" class="text-sm-center" color="success" type="success" outlined>
            {{ $t("hotel.valid") }}
          </v-alert>
        </v-flex>
        <v-flex xs12 class="text-sm-right">
          <v-btn color="primary" @click="createHotel()" :loading="hotelForm.loading" :disabled="hotelForm.disabled">Hotel anlegen</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-dialog v-model="staff.dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <h3 style="margin-bottom: 30px;">{{ $t('hotel.user.createStaff') }}</h3>
        </v-card-title>
        <v-card-text>
          <v-form v-model="staff.form" ref="staffForm" lazy-validation>
            <v-flex xs12 class="text-sm-left">
              <v-text-field
                color="primary"
                :label="$t('contact.firstName')"
                :rules="rules"
                v-model="staff.user.firstName"
                required/>
              <v-text-field
                color="primary"
                :label="$t('contact.lastName')"
                :rules="rules"
                v-model="staff.user.lastName"
                required/>
              <h3 style="margin-top: 10px">Anmeldedaten:</h3>
              <v-text-field
                color="primary"
                :label="$t('contact.email')"
                :rules="emailRules"
                v-model="staff.user.username"
                required/>
              <v-text-field
                color="primary"
                :label="$t('profile.password')"
                :rules="rules"
                v-model="staff.user.password"
                required/>
            </v-flex>
          </v-form>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="secondary" text @click.native="staff.dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" outlined :loading="staff.loading" :disabled="staff.loading" @click="submitStaff()">{{ $t('hotel.user.add') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <manage-room :id="id"/>
    <manage-rate-matrix :id="id"/>
    <v-dialog v-model="deleteRoomProcess.dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <h3 style="margin-bottom: 30px">Zimmer löschen</h3>
        </v-card-title>
        <v-card-text class="text-sm-left">
          Sind Sie sicher, dass Sie das Zimmer löschen möchten?
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="secondary" text @click.native="deleteRoomProcess.dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="error" outlined @click.native="deleteRoomDefinite()">{{ $t('delete') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      :color="snackbar.result"
      v-model="snackbar.value"
      :bottom="true"
      :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn
        color="white"
        text
        @click="snackbar.value = false">
        {{$t("close")}}
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
  import ManageRoom from './ManageRoom';
  import ManageRateMatrix from './templates/ManageRateMatrix';

  export default {
    name: 'CasablancaCreateHotel',
    components: {
      ManageRoom, ManageRateMatrix
    },
    data() {
      return {
        snackbar: {
          result: 'success',
          timeout: 6000,
          value: false,
          text: ''
        },
        hotelForm: {
          valid: false,
          loading: false,
          disabled: false
        },
        deleteRoomProcess: {
          dialog: false,
          room: undefined
        },
        editRoomProcess: {
          editing: false,
          room: undefined,
        },
        valid: undefined,
        tab: {
          value: 0,
          tabs: [
            { value: 0, label: this.$i18n.t('hotel.tabs.hotelInfo') },
            { value: 1, label: this.$i18n.t('hotel.tabs.user') },
            { value: 2, label: this.$i18n.t('hotel.tabs.room') }
          ]
        },
        hotelTypes: [
          { value: 'CITYHOTEL', label: this.$i18n.t('hotel.cityHotel') },
          { value: 'HOLIDAYHOTEL', label: this.$i18n.t('hotel.holidayHotel') },
        ],
        staff: {
          dialog: false,
          loading: false,
          form: undefined,
          user: {
            firstName: undefined,
            lastName: undefined,
            password: Math.random().toString(36).slice(-8),
            username: undefined,
          },
          headers: [
            { text: 'Staff', align: 'left', sortable: false },
            { text: this.$i18n.t('manageYieldStaff.actions'), align: 'left', sortable: false },
          ],
        },
        hotelDTO: {
          name: undefined,
          url: undefined,
          enabled: false,
          managerDTO: {
            firstName: undefined,
            lastName: undefined,
            password: Math.random().toString(36).slice(-8),
            username: undefined,
          },
          staffDTO: [],
          address: {
            city: undefined,
            region: undefined,
            land: undefined,
            addressLine1: undefined,
            addressLine2: undefined,
            zip: undefined,
            gps: {
              latitude: undefined,
              longitude: undefined,
            },
            landLine: undefined,
            mobile: undefined,
            fax: undefined,
            email: undefined
          },
          contact: {
            contactName: undefined,
            contactPhone: undefined,
            contactEmail: undefined,
          },
          externalId: undefined,
          channel: 'CASABLANCA',
          hotelType: undefined,
          currency: 'EUR',
          noChildren: false,
          initiated: false,
          roundPrice: false,
          casablancaHotelRooms: []
        },
        rules: [
          v => !!v || this.$i18n.t('form.required'),
        ],
        emailRules: [
          v => !!v || this.$i18n.t('form.required'),
          v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$i18n.t('form.email.valid'),
        ],
        room: {
          selected: undefined,
          rates: [],
          headers: [
            { text: this.$i18n.t('hotel.room'), align: 'left', sortable: false },
            { text: this.$i18n.t('hotel.settings.matrix'), align: 'left', sortable: false },
            { text: this.$i18n.t('manageYieldStaff.actions'), align: 'left', sortable: false },
          ],
        },
        id: Math.random().toString(36).slice(-8)
      };
    },
    mounted() {
      this.globalEvents.$emit('create_hotelCreated', true);
      this.globalEvents.$on('saveCasablancaRoom'.concat(this.id), (room) => {
        if (this.editRoomProcess.editing) {
          let index = -1;
          for (let i = 0; i < this.hotelDTO.casablancaHotelRooms.length; i += 1) {
            const room = this.hotelDTO.casablancaHotelRooms[i];
            if (room.name === this.editRoomProcess.room.name
              && room.externalId === this.editRoomProcess.room.externalId) {
              index = i;
              break;
            }
          }
          if (index > -1) {
            this.hotelDTO.casablancaHotelRooms.splice(index, 1, JSON.parse(JSON.stringify(room)));
            this.snackbar.result = 'success';
            this.snackbar.text = 'Zimmer wurde aktualisiert! (Es wurde noch nicht gespeichert)';
            this.snackbar.value = true;
          } else {
            this.snackbar.result = 'error';
            this.snackbar.text = 'Zimmer konnte nicht aktualisiert werden!';
            this.snackbar.value = true;
          }
        } else {
          this.hotelDTO.casablancaHotelRooms.push(room);
          this.snackbar.result = 'success';
          this.snackbar.text = 'Zimmer wurde hinzugefügt! (Es wurde noch nicht gespeichert)';
          this.snackbar.value = true;
        }
        this.editRoomProcess.editing = false;
      });
    },
    methods: {
      submitStaff() {
        if (this.$refs.staffForm.validate()) {
          this.staff.loading = true;
          this.hotelDTO.staffDTO.push(this.staff.user);
          this.staff.loading = false;
          this.staff.dialog = false;
          this.staff.user = {
            firstName: undefined,
            lastName: undefined,
            password: undefined,
            username: undefined,
          };
          this.$refs.staffForm.reset();
          this.staff.user.password = Math.random().toString(36).slice(-8);
        }
      },
      removeStaff(staff) {
        let index = -1;
        for (let i = 0; i < this.hotelDTO.staffDTO.length; i += 1) {
          if (this.hotelDTO.staffDTO[i].username === staff.username) {
            index = i;
            break;
          }
        }
        if (index !== -1) {
          this.hotelDTO.staffDTO.splice(index, 1);
        }
      },
      manageRateMatrix(room) {
        this.globalEvents.$emit('openManageRateMatrix_'.concat(this.id), room, this.hotelDTO);
      },
      createRoom() {
        const room = {
          name: '',
          externalId: '',
          minOccupancy: undefined,
          maxOccupancy: undefined,
          stdOccupancy: undefined,
          quantity: undefined,
          position: undefined,
          ignore: false,
          rateMatrix: [], // RATE MATRIX - NOT MANAGED HERE
          rates: [],      // RATE - NOT MANAGED HERE
          childrenPaymentMode: 'PERCENT',
          childrenRules: [],      // CHILDREN PRICE
          occupancyPaymentMode: 'PERCENT',
          occupancyRules: [],     // OCCUPANCY PRICING
          basePrices: []          // DEFINED PRICES
        };
        this.globalEvents.$emit('manageCasablancaRoom'.concat(this.id), this.hotelDTO.casablancaHotelRooms,
          room, true, this.hotelDTO);
      },
      editRoom(room) {
        this.editRoomProcess.editing = true;
        this.editRoomProcess.room = JSON.parse(JSON.stringify(room));
        this.globalEvents.$emit('manageCasablancaRoom'.concat(this.id), this.hotelDTO.casablancaHotelRooms,
          room, false, this.hotelDTO);
      },
      deleteRoom(room) {
        this.deleteRoomProcess.room = room;
        this.deleteRoomProcess.dialog = true;
      },
      deleteRoomDefinite() {
        let index = -1;
        for (let i = 0; i < this.hotelDTO.casablancaHotelRooms.length; i += 1) {
          const room = this.hotelDTO.casablancaHotelRooms[i];
          if (room.name === this.deleteRoomProcess.room.name
            && room.externalId === this.deleteRoomProcess.room.externalId) {
            index = i;
            break;
          }
        }
        if (index > -1) {
          this.hotelDTO.casablancaHotelRooms.splice(index, 1);
        }
        this.deleteRoomProcess.dialog = false;
      },
      createHotel() {
        if (!this.$refs.form.validate()) {
          this.snackbar.result = 'error';
          this.snackbar.text = this.$i18n.t('hotel.kognitiv.requiredFields');
          this.snackbar.value = true;
        } else if (this.hotelDTO.casablancaHotelRooms.length === 0) {
          this.snackbar.result = 'error';
          this.snackbar.text = this.$i18n.t('hotel.kognitiv.hasNoRoom');
          this.snackbar.value = true;
        } else if (this.hasNoRateMatrix(this.hotelDTO)) {
          this.snackbar.result = 'error';
          this.snackbar.text = this.$i18n.t('hotel.kognitiv.noRateMatrix');
          this.snackbar.value = true;
        } else {
          this.hotelForm.loading = true;
          this.hotelForm.disabled = true;
          const hotel = this.cleanHotel(this.hotelDTO);
          this.$http.post('hotels/casablanca', hotel).then(() => {
              this.globalEvents.$emit('create_hotelCreated', false);
              this.hotelForm.valid = true;
              this.hotelForm.loading = false;
            },
            (error) => {
              this.snackbar.result = 'error';
              if (error.bodyText !== undefined && error.bodyText !== null) {
                this.snackbar.text = error.bodyText.split('Detail:')[1];
              } else {
                this.snackbar.text = 'Ein Serverfehler ist aufgetreten, die Speicherung konnte nicht durchgeführt werden.';
              }
              this.snackbar.value = true;
              this.hotelForm.loading = false;
              this.hotelForm.disabled = false;
            });
        }
      },
      cleanHotel(hotelDTO) {
        const hotel = {
          name: hotelDTO.name,
          url: hotelDTO.url,
          enabled: hotelDTO.enabled,
          managerDTO: hotelDTO.managerDTO,
          staffDTO: hotelDTO.staffDTO,
          address: hotelDTO.address,
          contact: hotelDTO.contact,
          externalId: hotelDTO.externalId,
          channel: hotelDTO.channel,
          hotelType: hotelDTO.hotelType,
          currency: hotelDTO.currency,
          noChildren: hotelDTO.noChildren,
          roundPrice: hotelDTO.roundPrice,
          casablancaHotelRooms: []
        };
        for (let i = 0; i < hotelDTO.casablancaHotelRooms.length; i += 1) {
          const roomDTO = hotelDTO.casablancaHotelRooms[i];
          const room = {
            externalId: roomDTO.externalId,
            name: roomDTO.name,
            minOccupancy: Number(roomDTO.minOccupancy),
            maxOccupancy: Number(roomDTO.maxOccupancy),
            stdOccupancy: Number(roomDTO.stdOccupancy),
            quantity: Number(roomDTO.quantity),
            position: Number(roomDTO.position),
            availabilities: [],
            rateMatrix: JSON.stringify(roomDTO.rateMatrix),
            rates: JSON.parse(JSON.stringify(roomDTO.rates)),
            ignore: roomDTO.ignore,
            childrenPaymentMode: roomDTO.childrenPaymentMode,
            childrenRules: [],      // CHILDREN PRICE
            occupancyPaymentMode: roomDTO.occupancyPaymentMode,
            occupancyRules: [],     // OCCUPANCY PRICING
            basePrices: []          // DEFINED PRICES
          };

          if (!hotelDTO.noChildren && roomDTO.childrenRules !== undefined) {
            for (let k = 0; k < roomDTO.childrenRules.length; k += 1) {
              const childRuleDTO = roomDTO.childrenRules[k];
              room.childrenRules.push({
                age: childRuleDTO.age,
                price: ( childRuleDTO.price * 100 ) //RECALCULATE IN CENT
              });
            }
          }


          if (roomDTO.occupancyRules !== undefined) {
            for (let k = 0; k < roomDTO.occupancyRules.length; k += 1) {
              const occupancyRuleDTO = roomDTO.occupancyRules[k];
              room.occupancyRules.push({
                occupancy: occupancyRuleDTO.occupancy,
                payment: (occupancyRuleDTO.payment * 100) //RECALCULATE IN CENT
              });
            }
          }

          for (let k = 0; k < roomDTO.basePrices.length; k += 1) {
            const basePricesDTO = roomDTO.basePrices[k];
            room.basePrices.push({
              price: ( basePricesDTO.price * 100 ), //RECALCULATE IN CENT
              name: basePricesDTO.name,
              seasonIntervals: basePricesDTO.seasonIntervals
            });
          }

          hotel.casablancaHotelRooms.push(room);
        }
        return hotel;
      },
      hasNoRateMatrix(hotelDTO) {
        let hasNoRateMatrix = false;
        for (let i = 0; i < hotelDTO.casablancaHotelRooms.length; i += 1) {
          const room = hotelDTO.casablancaHotelRooms[i];
          if (room.rateMatrix === undefined) {
            hasNoRateMatrix = true;
            break;
          }
        }
        return hasNoRateMatrix;
      }
    }
  };
</script>

<style lang="scss">
  @import "../../../assets/scss/layout";

  .create-hotel-container {
    @include MQ(M) {
      width: 800px;
    }
    @include MQ(L) {
      width: 1000px;
    }
    @include MQ(XL) {
      width: 1200px;
    }

    .v-form {
      width: 100%;
    }

    .v-list {
      background: transparent !important;
      .v-list__tile {
        height: 20px !important;
        .v-list__tile__content {
          height: 20px !important;
        }
      }
    }
  }
</style>
